<script setup lang="ts">
  import { ColoredButton } from '@/shared/ui';

  defineProps<{
    confirmDisabled?: boolean;
    confirmLoading?: boolean;
  }>();

  const emit = defineEmits<{
    (e: 'close'): void;
    (e: 'confirm'): void;
  }>();
</script>

<template>
  <div
    id="actions-wrapper"
    class="flex justify-center gap-3"
  >
    <ColoredButton
      data-testid="modal-cancel"
      outlined
      color="gray-03"
      text="Cancelar"
      @click="emit('close')"
    />
    <ColoredButton
      data-testid="modal-confirm"
      text="Confirmar"
      :disabled="confirmDisabled"
      :loading="confirmLoading"
      @click="emit('confirm')"
    />
  </div>
</template>
